import { render, staticRenderFns } from "./second.vue?vue&type=template&id=ca606eb6&scoped=true&"
import script from "./second.vue?vue&type=script&lang=js&"
export * from "./second.vue?vue&type=script&lang=js&"
import style0 from "./second.vue?vue&type=style&index=0&id=ca606eb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca606eb6",
  null
  
)

export default component.exports